import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FaRegClock, FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { IoChatbubbleOutline } from "react-icons/io5";
import { CiVideoOn } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { LuVideo } from "react-icons/lu";
import { TiStarFullOutline } from "react-icons/ti";
import { TfiStatsUp } from "react-icons/tfi";
import { FcBarChart } from "react-icons/fc";
import { RiBarChart2Fill } from "react-icons/ri";
import { FcPrivacy } from "react-icons/fc";
import { GrSecure } from "react-icons/gr";
import { getCreatorDashboard } from "../../redux/actions/mindfulness";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FaRegStar } from "react-icons/fa";

import { CircularProgress } from "@mui/material";

// Styled Components
const DashboardContainer = styled.div`
  padding: 20px;
  background-color: #fff;
  font-family: Montserrat;

  margin: auto;
  margin-top: 90px;
  width: 80%;
`;

const Header = styled.div`
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  padding: 2.9375rem 2.1875rem;
  border-radius: 12px;
  color: white;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  box-sizing: border-box;
  padding-top: 3.75rem;
  border-top: 1px solid rgba(237, 30, 36, 1);
  border-radius: 15px 15px 0px 0px;
  background: linear-gradient(
    180deg,
    rgba(255, 106.66, 110.96, 1) 15.568%,
    rgba(237, 30, 36, 1) 100%
  );
`;

const HeaderTitle = styled.div`
  h1 {
    font-size: 1.875rem;
    margin: 0;
    font-weight: 400;
  }
  p {
    font-size: 1rem;
    font-weight: 400;
    opacity: 0.9;
    margin: 5px 0 0;
  }
`;

const EditProfileButton = styled.button`
  padding: 10px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  color: rgba(255, 255, 255, 1);

  font-family: Montserrat;
  font-size: 16.83px;
  font-weight: 400;
  line-height: 25.24px;
  letter-spacing: 0px;
  text-align: center;
  border: none;
  border-radius: 14.73px;
  background: rgba(255, 255, 255, 0.1);

  &:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 27px 25px;
  /* box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),0px 1px 2px -1px rgba(0, 0, 0, 0.1); */
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 15px;
`;

const StatIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: ${(props) => props.bgColor || "#f0f0f0"};
`;

const StatContent = styled.div`
  h3 {
    font-size: 14px;
    color: #666;
    font-weight: 400;
    margin: 0 0 5px 0;
  }
  p {
    font-size: 24px;
    font-weight: 400;
    margin: 0;
    color: #333;
  }
  small {
    font-size: 12px;
    color: #999;
    display: block;
    margin-top: 5px;
  }
`;

const ActionCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const ActionCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  transition: transform 0.2s ease;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;

  border-radius: 10px;

  &:hover {
    transform: translateY(-2px);
  }

  ${(props) =>
    props.primary &&
    `
  
background: linear-gradient(135.00deg, rgba(250.58, 43.81, 54.33, 1),rgba(231.15, 0, 10.76, 1) 100%);
    color: white;
    
    .icon {
      background-color: rgba(255, 255, 255, 0.2);
    }
    
    h3, p {
      color: white;
    }
  `}
`;

const ActionIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: ${(props) => props.bgColor || "#fa525a"};
  color: ${(props) => props.color || "#fff"};

  ${(props) =>
    props.primary &&
    ` 
  background: #fa525a;
    color: white;
  `}
`;

const ActionContent = styled.div`
  flex: 1;
  h3 {
    color: rgba(16, 24, 40, 1);

    font-family: Montserrat;
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: left;
  }
  p {
    color: rgba(74, 85, 101, 1);
    font-family: Montserrat;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 1rem;
  }
`;

const ArrowIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.primary ? "white" : "#666")};
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h2 {
    font-size: 1.25rem;
    font-weight: 400;
    margin: 0;
    color: #333;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #666;
    margin: 0;
  }

  .view-all {
    color: #ff6b6b;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const SessionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;

const SessionCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  position: relative;

  .edit-icon {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f0f0f0;
    border-radius: 4px;
    cursor: pointer;
    color: #666;

    &:hover {
      background-color: #e0e0e0;
    }
  }
`;

const SessionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: #ffebee;
  color: #ff6b6b;
  margin-bottom: 15px;
`;

const CategoryTag = styled.span`
  display: inline-block;
  background-color: ${(props) => props.bgColor || "#ffebee"};
  color: ${(props) => props.color || "#ff6b6b"};
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const FormatTag = styled.span`
  display: inline-block;
  background-color: #f5f5f5;
  color: #666;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const SessionTitle = styled.h3`
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 15px 0;
  color: #333;
  margin-bottom: 2rem;
`;

const SessionStats = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  font-weight: 400;

  .rating {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #ffc107;
    font-size: 14px;
    font-weight: 500;

    .star {
      font-size: 16px;
    }
  }

  .duration {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #666;
    font-weight: 400;
    font-size: 14px;
  }
`;

const SessionFooter = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;

  .price {
    font-weight: 400;
    color: #333;

    span {
      font-size: 12px;
      color: #666;
      font-weight: 400;
      display: block;
    }

    p {
      font-size: 18px;
      color: #101828;
      display: block;
      margin-top: "0.5rem";
    }
  }

  .bookings {
    font-weight: 500;
    color: #333;

    span {
      font-size: 12px;
      color: #666;
      font-weight: 400;
      display: block;
    }

    p {
      font-size: 18px;
      color: #101828;
      display: block;
      margin-top: "0.5rem";
    }
  }
`;

// Upcoming Bookings Section
const BookingsContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  margin-top: 20px;
`;

const BookingItem = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;

const BookingIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: #fef2f2;
  color: #ff6b6b;
  margin-right: 15px;
`;

const BookingDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;

  .session-title {
    font-weight: 400;
    color: #333;
    font-size: 16px;
  }

  .client-name {
    font-size: 14px;
    color: #666;
  }

  .format-tag {
    display: inline-block;
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    margin-left: 8px;
  }
`;

const BookingTime = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-left: 20px;
  gap: 0.5rem;
  margin-right: 4rem;

  .date {
    font-size: 14px;
    color: #101828;
    font-weight: 400;
  }

  .time {
    font-size: 12px;
    color: #666;
    font-weight: 400;
  }
`;

const BookingPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-left: 20px;

  .amount {
    font-size: 1rem;
    font-weight: 400;
    color: #333;
    margin-bottom: 5px;
  }

  .status {
    display: inline-block;
    background-color: #dcfce7;
    color: #00a63e;
    padding: 4px 8px;
    border-radius: 26843500px;
    background: rgba(220, 252, 231, 1);
    font-size: 12px;
    font-weight: 400;
  }
`;

const BookingArrow = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  margin-left: 10px;
`;

// Profile and Stats Cards
const InfoCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const InfoCard = styled.div`
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: flex-start;
  gap: 15px;

  ${(props) =>
    props.variant === "profile" &&
    `
    background-color: #fff3e0;
    border: 1px solid rgba(255, 214, 167, 1);
  `}

  ${(props) =>
    props.variant === "views" &&
    `
    background-color: #e3f2fd;
    border: 1px solid rgba(190, 219, 255, 1);
  `}
`;

const InfoIcon = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background-color: ${(props) => props.bgColor || "#f0f0f0"};
  color: ${(props) => props.color || "#333"};
`;

const InfoContent = styled.div`
  width: 100%;
  h3 {
    font-size: 16px;
    margin: 0 0 5px 0;
    font-weight: 600;
    color: #333;
  }
  p {
    font-size: 14px;
    margin: 0;
    color: #666;
  }
  .value {
    color: rgba(21, 93, 252, 1);

    font-family: Montserrat;
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0px;
    text-align: left;
    margin: 5px 0;
  }
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 10px;
`;

const ProgressFill = styled.div`
  height: 100%;
  background-color: #ff6b6b;
  width: ${(props) => props.width}%;
`;

const LoaderWrapper = styled.div`
  margin-top: 25%;
  text-align: center;
`;

const CreatorDashboard = () => {
  const dashboardData =
    useSelector((state) => state?.mindfulness?.creatorDashboard) ?? {};

  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getCreatorDashboard());
    setIsLoading(false);
  }, []);

  console.log("dashboardData", dashboardData);

  if (isLoading) {
    return (
      <LoaderWrapper>
        <CircularProgress sx={{ color: "#ED1E24" }} size={50} />
      </LoaderWrapper>
    );
  }

  return (
    <DashboardContainer>
      {/* Header */}
      <Header>
        <HeaderTitle>
          <h1>Creator Dashboard</h1>
          <p>Manage your counseling sessions and bookings</p>
        </HeaderTitle>
        <EditProfileButton>
          <img src="/Image/mindfulness/edit-profile.svg" />
          Edit Profile
        </EditProfileButton>
      </Header>

      {/* Stats Cards */}
      <StatsContainer>
        <StatCard>
          <StatIcon bgColor="#FFE2E2">
            <img src="/Image/mindfulness/cal.svg" />
          </StatIcon>
          <StatContent>
            <h3>Total Sessions</h3>
            <p>{dashboardData?.sessions?.total_sessions || 0}</p>
            <small>
              {dashboardData?.sessions?.sessions?.filter((s) => s.is_active)
                .length || 0}{" "}
              active sessions
            </small>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon bgColor="#E8F0FE">
            <img src="/Image/mindfulness/total-booking.svg" />
          </StatIcon>
          <StatContent>
            <h3>Total Bookings</h3>
            <p>{dashboardData?.total_bookings?.total_bookings || 0}</p>
            <small>
              {dashboardData?.total_bookings?.bookings?.length || 0} completed
            </small>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon bgColor="#FCE8E6">
            <img src="/Image/mindfulness/clock.svg" />
          </StatIcon>
          <StatContent>
            <h3>Total Hours</h3>
            <p>{dashboardData?.total_hours_conducted || 0}h</p>
            <small>
              {dashboardData?.total_bookings?.total_bookings || 0} sessions
            </small>
          </StatContent>
        </StatCard>

        <StatCard>
          <StatIcon bgColor="#e8f5e9">
            <span>$</span>
          </StatIcon>
          <StatContent>
            <h3>Total Earnings</h3>
            <p>
              ₹
              {(() => {
                const sessions = dashboardData?.sessions?.sessions || [];
                const totalEarnings = sessions.reduce((sum, session) => {
                  const conversationTypes = Object.keys(
                    session.conversation_type_amount || {},
                  );
                  const firstType = conversationTypes[0];
                  const price = firstType
                    ? session.conversation_type_amount[firstType]
                    : 0;
                  return sum + price * session.total_bookings;
                }, 0);
                return totalEarnings.toLocaleString();
              })()}
            </p>
            <small>From all sessions</small>
          </StatContent>
        </StatCard>
      </StatsContainer>

      {/* Action Cards */}
      <ActionCardsContainer>
        <ActionCard primary onClick={() => history.push("/session_form")}>
          <ActionIcon className="icon" primaryd>
            <FaPlus />
          </ActionIcon>
          <ActionContent>
            <h3 style={{ color: "#fff" }}>Create New Session</h3>
            <p style={{ color: "#fff" }}>
              Add a new counseling session for students
            </p>
          </ActionContent>
          {/* <ArrowIcon primary>→</ArrowIcon> */}
        </ActionCard>

        <ActionCard onClick={() => history.push("/manage_sessions")}>
          <ActionIcon className="icon" bgColor="#FAF5FF" color="#9810FA">
            <img src="/Image/mindfulness/Manage-sessions.svg" />
          </ActionIcon>
          <ActionContent>
            <h3>Manage My Sessions</h3>
            <p>View and edit all your sessions</p>
          </ActionContent>
          {/* <ArrowIcon>→</ArrowIcon> */}
        </ActionCard>

        <ActionCard onClick={() => history.push("/session_reviews")}>
          <ActionIcon className="icon" bgColor="#FEFCE8" color="#D08700">
            {/* <img src="/Image/mindfulness/wellnes  s-resources.svg" /> */}
            <FaRegStar color="D08700" size={24} />
          </ActionIcon>
          <ActionContent>
            <h3>Reviews & Ratings</h3>
            <p>View all your client reviews</p>
          </ActionContent>
        </ActionCard>
      </ActionCardsContainer>

      {/* Active Sessions */}
      <SectionHeader>
        <div>
          <h2>My Active Sessions</h2>
          <p>Sessions available for booking</p>
        </div>
        <p
          onClick={() => history.push("/manage_sessions")}
          className="view-all"
        >
          View All →
        </p>
      </SectionHeader>

      <SessionsContainer>
        {(dashboardData?.sessions?.sessions || []).map((session) => {
          // Get conversation types and amounts from conversation_type_amount object
          const conversationTypes = Object.keys(
            session.conversation_type_amount || {},
          );
          const firstType = conversationTypes[0];
          const price = firstType
            ? session.conversation_type_amount[firstType]
            : 0;
          const format = firstType
            ? firstType.charAt(0).toUpperCase() +
              firstType.slice(1).replace("_", " ")
            : "N/A";

          return (
            <SessionCard key={session.id}>
              <div className="edit-icon">
                {" "}
                <FaRegEdit />{" "}
              </div>
              <SessionIcon>
                {firstType === "chat" && (
                  <IoChatbubbleOutline color="#ff6b6b" />
                )}
                {firstType === "call" && <IoCallOutline color="#ff6b6b" />}
                {(firstType === "video" || firstType === "video_call") && (
                  <LuVideo color="#ff6b6b" />
                )}
              </SessionIcon>
              <div>
                <CategoryTag bgColor="#ffebee" color="#ff6b6b">
                  {session.category}
                </CategoryTag>
                <FormatTag>{format}</FormatTag>
              </div>
              <SessionTitle>{session.name}</SessionTitle>
              <SessionStats>
                <div className="rating">
                  <TiStarFullOutline color="#EFBF04" />
                  <span>
                    {session.average_rating || "0"}
                    {/* ({session.SessionRating?.length || 0}) */}
                  </span>
                </div>
                <div className="duration">
                  <FaRegClock color="#4A5565" />
                  <span>{session.duration} min</span>
                </div>
              </SessionStats>
              <SessionFooter>
                <div className="price">
                  <span>Price</span>
                  <p> ₹{price} </p>
                </div>
                <div className="bookings">
                  <span>Bookings</span>
                  <p> {session.total_bookings} </p>
                </div>
              </SessionFooter>
            </SessionCard>
          );
        })}
      </SessionsContainer>

      {/* Upcoming Bookings */}
      <SectionHeader style={{ marginTop: "2rem" }}>
        <div>
          <h2>Upcoming Bookings</h2>
          <p style={{ marginTop: "0.75rem" }}>{`${
            dashboardData?.upcoming_bookings?.length || 0
          } Sessions Scheduled`}</p>
        </div>
        <p onClick={() => history.push("/creator_bookings")} className="view-all">
          View All →
        </p>
      </SectionHeader>

      <BookingsContainer>
        {dashboardData?.upcoming_bookings?.length === 0 && <p style={{textAlign: 'center', fontWeight: 400}}>No Bookings Available</p>}
        {(dashboardData?.upcoming_bookings || []).map((booking) => (
          <BookingItem key={booking.id}>
            <BookingIcon>
              {booking.format === "Chat" || booking.format === "chat" ? (
                <IoChatbubbleOutline color="#ED1E24" />
              ) : booking.format === "Video" ||
                booking.format === "video" ||
                booking.format === "video_call" ? (
                <CiVideoOn color="#ED1E24" />
              ) : (
                <IoCallOutline color="#ED1E24" />
              )}
            </BookingIcon>
            <BookingDetails>
              <div className="session-title">
                {booking.sessionTitle || booking.session_title}
              </div>
              <div className="client-name">
                {booking.clientName || booking.client_name}
                <span className="format-tag">{booking.format}</span>
              </div>
            </BookingDetails>
            <BookingTime>
              <div className="date">{booking.date}</div>
              <div className="time">{booking.time}</div>
            </BookingTime>
            <BookingPrice>
              <div className="amount">₹{booking.price}</div>
              <div className="status">{booking.status}</div>
            </BookingPrice>
          </BookingItem>
        ))}
      </BookingsContainer>

      {/* Profile Completion and Session Views */}
      <InfoCardsContainer>
        <InfoCard variant="profile">
          <InfoIcon bgColor="#fff" color="#155DFC">
            <RiBarChart2Fill color="#155DFC" />
          </InfoIcon>
          <InfoContent>
            <h3>Profile Completion</h3>
            <p>
              Your profile is {dashboardData?.profile_completion || 85}%
              complete
            </p>
            <ProgressBar>
              <ProgressFill width={dashboardData?.profile_completion || 85} />
            </ProgressBar>
          </InfoContent>
        </InfoCard>

        <InfoCard variant="views">
          <InfoIcon bgColor="#fff" color="#155DFC">
            <TfiStatsUp color="#155DFC" />
          </InfoIcon>
          <InfoContent color="#1976d2">
            <h3>Session Views</h3>
            <p>Who viewed your sessions</p>
            <div className="value">
              {(dashboardData?.session_views || 0).toLocaleString()}
            </div>
          </InfoContent>
        </InfoCard>
      </InfoCardsContainer>
    </DashboardContainer>
  );
};

export default CreatorDashboard;
